import { render } from "./WalletSelector.vue?vue&type=template&id=54fe5da5"
import script from "./WalletSelector.vue?vue&type=script&lang=js"
export * from "./WalletSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__